module.exports = __webpack_public_path__ + "static/media/bogota.8751efec.jpg";